interface CheckboxProps {
  disabled?: boolean;
  label: string;
  value?: string | null;
  isChecked?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Checkbox = ({
  disabled,
  label,
  value,
  isChecked,
  onChange,
}: CheckboxProps) => {
  const onCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e);
  };

  return (
    <div>
      <label
        className={`flex items-center gap-[25px] ${
          disabled ? "opacity-30 cursor-default" : "cursor-pointer"
        }`}
      >
        <input
          type="checkbox"
          checked={isChecked}
          disabled={disabled}
          value={value || undefined}
          onChange={onCheckboxChange}
          className={`
            appearance-none
            w-5 h-5
            border-2 border-tm-c-brand
            rounded-[3px]
            grid place-content-center
            m-0
            flex-none
            before:content-['']
            before:w-[10px] before:h-[10px]
            before:scale-0
            before:transition-transform
            before:duration-[120ms]
            before:ease-in-out
            checked:before:scale-100
            checked:before:bg-tm-c-brand
            ${disabled ? "cursor-default" : "cursor-pointer"}
          `}
        />
        <span
          className={`text-[17px] ${
            disabled ? "cursor-default" : "cursor-pointer"
          }`}
        >
          {label}
        </span>
      </label>
    </div>
  );
};

export default Checkbox;
